import { db } from '../firebaseConfig';
import { collection, addDoc, doc, updateDoc, deleteDoc } from 'firebase/firestore';

/**
 * Service to handle routine persistence.
 *
 * Routines are owner-scoped: each doc carries the creator's uid as
 * ownerUserId (enforced by the routines create rule). `exercises` is an
 * ordered array of { exerciseId, order } assembled by the caller — the
 * selection order IS the training order.
 */
export const createRoutine = async (ownerUserId, name, exercises) => {
  try {
    const docRef = await addDoc(collection(db, "routines"), {
      name,
      ownerUserId,
      exercises
    });

    console.log("Routine Assembled: ", docRef.id);
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Transmission Error: ", error);
    return { success: false, error };
  }
};

/**
 * Update an existing routine's name/exercises. ownerUserId is never
 * touched — the update rule requires it stay the same before/after.
 */
export const updateRoutine = async (routineId, name, exercises) => {
  try {
    await updateDoc(doc(db, "routines", routineId), { name, exercises });
    console.log("Routine Updated: ", routineId);
    return { success: true, id: routineId };
  } catch (error) {
    console.error("Transmission Error: ", error);
    return { success: false, error };
  }
};

/**
 * Delete a routine definition. Logged history is untouched -- logs
 * reference exerciseId, not routineId, and carry routineName as a plain
 * string copied at log time, not a live reference, so past workouts stay
 * exactly as they were after the routine that produced them is deleted.
 */
export const deleteRoutine = async (routineId) => {
  try {
    await deleteDoc(doc(db, "routines", routineId));
    console.log("Routine Deleted: ", routineId);
    return { success: true };
  } catch (error) {
    console.error("Transmission Error: ", error);
    return { success: false, error };
  }
};
